import { Component, Mixins } from "vue-property-decorator";
import ScoutingsMixin from "@/mixins/http/ScoutingsMixin";
import RequestsMixin from "@/mixins/http/RequestsMixin";
import ScoutingAreaMixin from "@/mixins/http/ScoutingAreaMixin";

@Component
class ScoutingService extends Mixins(
  ScoutingsMixin,
  ScoutingAreaMixin,
  RequestsMixin,
) {}

export default new ScoutingService();
